import { GroupByMode, noGroupingId } from '@griply/types';
import { getHiddenLinkedItemLabels, getNewTaskPrefill } from '@griply/utils';
import React from 'react';
import { NewTaskRow } from 'shared/components/connected/new-task-row';
import {
  RenderItemProps,
  TaskListItemTypes,
} from 'shared/components/ui/virtualized-tree-list';

import { TreeGoalRow } from '../tree-goal-row';
import { TreeTaskCard } from '../tree-task-card';
import { useNoGroupingRenderData } from './no-grouping-render-context';

export const NoGroupingRenderItem: React.FC<RenderItemProps> = ({
  item,
  tree,
  itemInstance,
  isMultiSelectModifierPressed,
}) => {
  const {
    tasksMap,
    tasks,
    today,
    filterDocument,
    defaultNewTaskDate,
    goalId,
    lifeAreaId,
    tagId,
    displayDue,
    showRepeatingAsTodo,
    hideNewTaskRow,
    goalRenderData,
  } = useNoGroupingRenderData();

  if (item.type === TaskListItemTypes.GoalDeadline) {
    return goalRenderData ? (
      <TreeGoalRow sourceId={item.sourceId} data={goalRenderData} />
    ) : null;
  }

  if (item.type === TaskListItemTypes.NewTask && !hideNewTaskRow) {
    const prefill = getNewTaskPrefill({
      groupByMode: GroupByMode.None,
      groupSectionId: noGroupingId,
      groupSetting: { goalId, lifeAreaId, tagId },
      today,
      defaultNewTaskDate,
      filterDocument,
    });
    return (
      <NewTaskRow
        goal={prefill.goalId}
        lifeArea={prefill.lifeAreaId}
        tags={prefill.tagIds}
        startTime={null}
        duration={null}
        date={prefill.startDate}
      />
    );
  }

  const task = tasksMap[item.sourceId];
  if (!task) {
    return null;
  }

  const { hideGoal, hideLifeArea } = getHiddenLinkedItemLabels(task, {
    goalId,
    lifeAreaId,
  });

  return (
    <TreeTaskCard
      task={task}
      tree={tree}
      item={itemInstance}
      tasks={tasks}
      isMultiSelectModifierPressed={isMultiSelectModifierPressed}
      displayDue={displayDue}
      showRepeatingAsTodo={showRepeatingAsTodo}
      hideGoal={hideGoal}
      hideLifeArea={hideLifeArea}
    />
  );
};
